import React from "react";
import { OvsTypeCard, OvsTypeSection } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import { renderRichText } from "@/lib/richText";

interface OvsTypeSectionProps {
  blok?: OvsTypeSection & SbBlokData;
}

const OvsTypeSectionComponent: React.FC<OvsTypeSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { type, title, types, subtitle } = blok;

  // Set background and container classes based on type
  const bgClass = type === 'asvs' ? 'bg-light' : 'bg-white';
  const containerClass = `crest-ovs-${type === 'asvs' ? 'apps' : 'mobile'}-container`;

  return (
    <div
      {...storyblokEditable(blok)}
      className={`${bgClass} ${containerClass} component-cards-content py-4 py-md-5`}
    >
      <div className="container">
        <h2 className="col-24 text-center mb-5 text-secondary">
          {title}
        </h2>
        {subtitle && (
          <div
            className="text-center mb-4"
            dangerouslySetInnerHTML={{ __html: renderRichText(subtitle) }}
          />
        )}
      </div>

      {types?.map((card, index) => {
        const typedCard = card as OvsTypeCard & SbBlokData;
        return (
          <div key={typedCard._uid} {...storyblokEditable(typedCard)} className="col mb-3 text-center">
            {index === 0 ? (
              <div className={`card card-lighter overflow-hidden h-100 crest-ovs-${type === 'asvs' ? 'apps' : 'mobile'}`}>
                <div className="p-4">
                  {typedCard.icon?.filename && (
                    <Image
                      src={typedCard.icon.filename}
                      width={120}
                      height={120}
                      alt={typedCard.title || ''}
                      className="img-fluid mb-2 mx-auto component-cards-content-icon"
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      loading="lazy"
                      quality={75}
                    />
                  )}
                  <h3 className="mt-2 text-secondary">{typedCard.title}</h3>
                  <p className="lead mb-0">
                    {typeof typedCard.description === 'string'
                      ? typedCard.description
                      : renderRichText(typedCard.description)}
                  </p>
                </div>
              </div>
            ) : (
              <div className="card card-lighter overflow-hidden h-100">
                <div className="p-4">
                  <h3 className="mt-2 text-secondary">
                    {typedCard.title}
                    {typedCard.subtitle && (
                      <span className="d-block text-muted">{typedCard.subtitle}</span>
                    )}
                  </h3>
                  <p className="lead mb-0">
                    {typeof typedCard.description === 'string'
                      ? typedCard.description
                      : renderRichText(typedCard.description)}
                  </p>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OvsTypeSectionComponent;